/**
 * 과세 상태를 나타내는 enum 값이다.
 *
 * @property TAXABLE 과세
 * @property EXCEMPT 비과세
 * @property SMALL 영세 (영세사업자)
 */
export enum TaxStatus {
    TAXABLE = 'taxable',
    EXCEMPT = 'excempt',
    SMALL = 'small',
}
